import Skeleton from 'components/Skeleton';
import React from 'react';

export type MenuCardSkeletonProps = {
  className?: string;
};
export const MenuCardSkeleton = ({
  className = 'flex flex-col m-1',
}: MenuCardSkeletonProps) => (
  <div className={className}>
    <div className='flex items-center mb-2'>
      <Skeleton
        variant='circle'
        width={38}
        height={32}
        style={{ marginRight: 8, marginLeft: 8 }}
      />
      <Skeleton variant='rectangle' width='100%' height={25} />
    </div>
    <Skeleton variant='rectangle' width='100%' height={200} />
  </div>
);
